var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('video',{attrs:{"width":"98%","height":"98%","controls":""}},[_c('source',{attrs:{"src":"/images/mp4/movie.mp4","type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }